import type { ReactNode } from 'react';

import type { TRootElement } from '@shared/dream-components';
import { RootElement } from '@shared/dream-components';

interface Props {
  node: TRootElement;
  children: ReactNode | ReactNode[];
  className?: string;
}

const Doc = ({ node, children, className }: Props) => {
  return (
    <RootElement element={node} className={className}>
      {children}
    </RootElement>
  );
};

export default Doc;
